import {PermissionEntityType} from '@toolify/server/src/models/mongoose/PermissionModel/enum/PermissionEntityType'
import {i18n} from '@toolify/client/src/setup/i18n'

export function getRequestedForEntityPhrase(entityType?: PermissionEntityType | null): string {
  const {t} = i18n.global
  switch(entityType) {
  case PermissionEntityType.User:
    return t('notifications.workspacePermissionRequest.forUser')
  case PermissionEntityType.Group:
    return t('notifications.workspacePermissionRequest.forGroup')
  case PermissionEntityType.App:
    return t('notifications.workspacePermissionRequest.forApp')
  case PermissionEntityType.Link:
    return t('notifications.workspacePermissionRequest.forLink')
  case PermissionEntityType.Bot:
    return t('notifications.workspacePermissionRequest.forBot')
  default:
    return t('notifications.workspacePermissionRequest.forEntity')
  }
}
